const ProductSang = [
    {
        ID : 60 ,
        Name: " سنگ تراورتن ",
        ImageURL: "image/Stone/1-2.jpg",
        CategoryID: 1001 ,
        Details: "کرم نسکافه ای ممتاز " ,
        CompanyName: "ابرکوه" , 
    },
    {
        ID : 64 ,
        Name: " سنگ مرمر ",
        ImageURL: "image/new-cat-2-6.jpeg",
        CategoryID: 1004,
        Details: "" ,
        CompanyName: "_" , 
    },
    {
        ID : 131 ,
        Name: " سنگ لاشتر ",
        ImageURL: "image/Stone/4-20.jpeg",
        CategoryID: 1002,
        Details: " بوش همر چرمی  " ,
        CompanyName: "لاشتر" , 
    },
    {
        ID : 150 ,
        Name: " سنگ اسلب ",
        ImageURL: "image/Stone/3-5.jpeg",
        CategoryID: 1004,
        Details: "مرمر بلک رز" ,
        CompanyName: "_" , 
    },
    {
        ID : 138 ,
        Name: " مرمریت گلدن ",
        ImageURL: "image/Stone/4-35.jpeg",
        CategoryID: 1002,
        Details: "بلک 40 طولی" ,
        CompanyName: "نجف آباد" , 
    },
    {
        ID : 61 ,
        Name: " سنگ تراورتن ",
        ImageURL: "image/Stone/1-1.jpeg",
        CategoryID: 1001,
        Details: "آبگرم " ,
        CompanyName: "محلات" , 
    },
    {
        ID : 67 ,
        Name: " سنگ تراورتن ",
        ImageURL: "image/Stone/1-3.jpeg",
        CategoryID: 1001,
        Details: "سوپر" ,
        CompanyName: "ابیانه" , 
    },
    {
        ID : 68 ,
        Name: " سنگ تراورتن ",
        ImageURL: "image/Stone/1-4.jpeg",
        CategoryID: 1001,
        Details: "ممتاز" ,
        CompanyName: "ابیانه" , 
    },
    {
        ID : 69 ,
        Name: " سنگ تراورتن ",
        ImageURL: "image/Stone/1-5.jpeg",
        CategoryID: 1001,
        Details: " کرم ممتاز" ,
        CompanyName: "تکاب" , 
    },
    {
        ID : 70 ,
        Name: " سنگ تراورتن ",
        ImageURL: "image/Stone/1-6.jpeg",
        CategoryID: 1001,
        Details: "شکلاتی" ,
        CompanyName: "حاجی آباد" , 
    },
    {
        ID : 71 ,
        Name: " سنگ تراورتن ",
        ImageURL: "image/Stone/1-9.jpeg",
        CategoryID: 1001,
        Details: "کرم بی موج" ,
        CompanyName: "حاجی آباد" , 
    },
    {
        ID : 72 ,
        Name: " سنگ تراورتن ",
        ImageURL: "image/Stone/1-10.jpeg",
        CategoryID: 1001,
        Details: "گل پنبه ای" ,
        CompanyName: "حاجی آباد" , 
    },
    {
        ID : 73 ,
        Name: " سنگ تراورتن ",
        ImageURL: "image/Stone/1-7.jpeg",
        CategoryID: 1001,
        Details: "متاز" ,
        CompanyName: "حاجی آباد" , 
    },
    {
        ID : 74 ,
        Name: " سنگ تراورتن ",
        ImageURL: "image/Stone/1-8.jpeg",
        CategoryID: 1001,
        Details: "موج دار" ,
        CompanyName: "حاجی آباد" , 
    },
    {
        ID : 75 ,
        Name: " سنگ تراورتن ",
        ImageURL: "image/Stone/1-11.jpeg",
        CategoryID: 1001,
        Details: "سوپر" ,
        CompanyName: "دره بخاری" , 
    },
    {
        ID : 76 ,
        Name: " سنگ تراورتن ",
        ImageURL: "image/Stone/1-12.jpeg",
        CategoryID: 1001,
        Details: "کرم ممتاز" ,
        CompanyName: "دره بخاری" , 
    },
    {
        ID : 77 ,
        Name: " سنگ تراورتن ",
        ImageURL: "image/Stone/1-13.jpeg",
        CategoryID: 1001,
        Details: "کرم موج دار" ,
        CompanyName: "دره بخاری" , 
    },
    {
        ID : 78 ,
        Name: " سنگ تراورتن ",
        ImageURL: "image/Stone/1-14.jpeg",
        CategoryID: 1001,
        Details: "دودی" ,
        CompanyName: "تکاب" , 
    },
    {
        ID : 79 ,
        Name: " سنگ تراورتن ",
        ImageURL: "image/Stone/1-37.jpg",
        CategoryID: 1001,
        Details: "درجه یک" ,
        CompanyName: "رامشه" , 
    },
    {
        ID : 80 ,
        Name: " سنگ تراورتن ",
        ImageURL: "image/Stone/1-39.jpg",
        CategoryID: 1001,
        Details: "کرم" ,
        CompanyName: "رامشه" , 
    },
    {
        ID : 81 ,
        Name: " سنگ تراورتن ",
        ImageURL: "image/Stone/1-15.jpeg",
        CategoryID: 1001,
        Details: "سفید" ,
        CompanyName: "محلات" , 
    },
    {
        ID : 82 ,
        Name: " سنگ تراورتن ",
        ImageURL: "image/Stone/1-16.jpeg",
        CategoryID: 1001,
        Details: "سیلور" ,
        CompanyName: "تکاب" , 
    },
    {
        ID : 83 ,
        Name: " سنگ تراورتن ",
        ImageURL: "image/Stone/1-2.jpg",
        CategoryID: 1001,
        Details: "شکلاتی" ,
        CompanyName: "دهشیر" , 
    },
    {
        ID : 84 ,
        Name: " سنگ تراورتن ",
        ImageURL: "image/Stone/1-17.jpeg",
        CategoryID: 1001,
        Details: "شکلاتی" ,
        CompanyName: "کاشان" , 
    },
    {
        ID : 85 ,
        Name: " سنگ تراورتن ",
        ImageURL: "image/Stone/1-18.jpeg",
        CategoryID: 1001,
        Details: "بی موج" ,
        CompanyName: "عباس آباد" , 
    },
    {
        ID : 86 ,
        Name: " سنگ تراورتن ",
        ImageURL: "image/Stone/1-19.jpeg",
        CategoryID: 1001,
        Details: "درجه 2" ,
        CompanyName: "عباس آباد" , 
    },
    {
        ID : 87 ,
        Name: " سنگ تراورتن ",
        ImageURL: "image/Stone/1-20.jpeg",
        CategoryID: 1001,
        Details:  "سوپر" ,
        CompanyName: "عباس آباد" , 
    },
    {
        ID : 88 ,
        Name: " سنگ تراورتن ",
        ImageURL: "image/Stone/1-21.jpeg",
        CategoryID: 1001,
        Details:  "عرض 30 و 35" ,
        CompanyName: "عباس آباد" , 
    },
    {
        ID : 89 ,
        Name: " سنگ تراورتن ",
        ImageURL: "image/Stone/1-24.jpeg",
        CategoryID: 1001,
        Details:  "کرم" ,
        CompanyName: "عباس آباد" , 
    },
    {
        ID : 90 ,
        Name: " سنگ تراورتن ",
        ImageURL: "image/Stone/1-22.jpeg",
        CategoryID: 1001,
        Details:  "ممتاز" ,
        CompanyName: "عباس آباد" , 
    },
    {
        ID : 91 ,
        Name: " سنگ تراورتن ",
        ImageURL: "image/Stone/1-23.jpeg",
        CategoryID: 1001,
        Details:  "موج پیچ" ,
        CompanyName: "عباس آباد" , 
    },
    {
        ID : 92 ,
        Name: " سنگ تراورتن ",
        ImageURL: "image/Stone/1-25.jpeg",
        CategoryID: 1001,
        Details:  "عسلی" ,
        CompanyName: "کاشان" , 
    },
    {
        ID : 93 ,
        Name: " سنگ تراورتن ",
        ImageURL: "image/Stone/1-30.jpeg",
        CategoryID: 1001,
        Details:  "کرم درجه 1" ,
        CompanyName: "ابرکوه" , 
    },
    {
        ID : 94 ,
        Name: " سنگ تراورتن ",
        ImageURL: "image/new-cat-2-1.jpg",
        CategoryID: 1001,
        Details:  "کرم درجه 2" ,
        CompanyName: "ابرکوه" , 
    },
    {
        ID : 95 ,
        Name: " سنگ تراورتن ",
        ImageURL: "image/Stone/1-5.jpeg",
        CategoryID: 1001,
        Details:  "کرم",
        CompanyName: "طرق" , 
    },
    {
        ID : 96 ,
        Name: " سنگ تراورتن ",
        ImageURL: "image/Stone/1-32.jpeg",
        CategoryID: 1001,
        Details:  "کرم",
        CompanyName: "کاشان" , 
    },
    {
        ID : 97 ,
        Name: " سنگ تراورتن ",
        ImageURL: "image/Stone/1-30.jpeg",
        CategoryID: 1001,
        Details:  "کرم",
        CompanyName: "محلات" , 
    },
    {
        ID : 98 ,
        Name: " سنگ تراورتن ",
        ImageURL: "image/Stone/1-31.jpeg",
        CategoryID: 1001,
        Details:  "کرم ممتاز",
        CompanyName: "رامشه" , 
    },
    {
        ID : 99 ,
        Name: " سنگ تراورتن ",
        ImageURL: "image/Stone/1-33.jpeg",
        CategoryID: 1001,
        Details:  "کرم ",
        CompanyName: "یزد" , 
    },
    {
        ID : 100 ,
        Name: " سنگ تراورتن ",
        ImageURL: "image/Stone/1-34.jpeg",
        CategoryID: 1001,
        Details:  "سوپر ",
        CompanyName: "کمشچه" , 
    },
    {
        ID : 101 ,
        Name: " سنگ تراورتن ",
        ImageURL: "image/Stone/1-35.jpeg",
        CategoryID: 1001,
        Details:  "ممتاز ",
        CompanyName: "کمشچه" , 
    },
    {
        ID : 102 ,
        Name: " سنگ تراورتن ",
        ImageURL: "image/Stone/1-26.jpeg",
        CategoryID: 1001,
        Details:  " ",
        CompanyName: "لوشان" , 
    },
    {
        ID : 103 ,
        Name: " سنگ اسلب ",
        ImageURL: "image/Stone/4-3.jpeg",
        CategoryID: 1002,
        Details: "پرشین سیلک" ,
        CompanyName: "" , 
    },
    {
        ID : 104 ,
        Name: " سنگ اسلب ",
        ImageURL: "image/Stone/4-1.jpeg",
        CategoryID: 1002,
        Details: "تری دی بلک (3d black)" ,
        CompanyName: "_" , 
    },
    {
        ID : 105 ,
        Name: " سنگ اسلب ",
        ImageURL: "image/Stone/4-2.jpeg",
        CategoryID: 1002,
        Details: "دهبید اسپایدر موج دار" ,
        CompanyName: "_" , 
    },
    {
        ID : 106 ,
        Name: " سنگ اسلب ",
        ImageURL: "image/Stone/4-6.jpeg",
        CategoryID: 1002,
        Details: "کریستال زمرد" ,
        CompanyName: "_" , 
    },
    {
        ID : 107 ,
        Name: " سنگ اسلب ",
        ImageURL: "image/Stone/4-7.jpeg",
        CategoryID: 1002,
        Details: "کریستال  لایبید" ,
        CompanyName: "_" , 
    },
    {
        ID : 108 ,
        Name: " سنگ اسلب ",
        ImageURL: "image/Stone/4-8.jpeg",
        CategoryID: 1002,
        Details: "گلدن بلک" ,
        CompanyName: "محلات" , 
    },
    {
        ID : 109 ,
        Name: " سنگ اسلب ",
        ImageURL: "image/Stone/4-4.jpeg",
        CategoryID: 1002,
        Details: "" ,
        CompanyName: "لاشتر" , 
    },
    {
        ID : 110 ,
        Name: " سنگ اسلب ",
        ImageURL: "image/Stone/4-5.jpeg",
        CategoryID: 1002,
        Details: "" ,
        CompanyName: "ماکو" , 
    },
    {
        ID : 111 ,
        Name: " سنگ بادبر ",
        ImageURL: "image/Stone/4-9.jpeg",
        CategoryID: 1002,
        Details: "اداوی" ,
        CompanyName: "_" , 
    },
    {
        ID : 112 ,
        Name: " سنگ بادبر ",
        ImageURL: "image/Stone/4-10.jpeg",
        CategoryID: 1002,
        Details: "جوشقان" ,
        CompanyName: "_" , 
    },
    {
        ID : 113 ,
        Name: " سنگ بادبر ",
        ImageURL: "image/Stone/4-11.jpeg",
        CategoryID: 1002,
        Details: "" ,
        CompanyName: "لاشتر" , 
    },
    {
        ID : 114 ,
        Name: " سنگ پلاک ",
        ImageURL: "image/Stone/4-4.jpeg",
        CategoryID: 1002,
        Details: "مرمریت" ,
        CompanyName: "صلصالی" , 
    },
    {
        ID : 115 ,
        Name: " سنگ پله ",
        ImageURL: "image/Stone/4-16.jpeg",
        CategoryID: 1002,
        Details: "پرطاووسی" ,
        CompanyName: "یزد" , 
    },
    {
        ID : 116 ,
        Name: " سنگ پله ",
        ImageURL: "image/Stone/4-15.jpeg",
        CategoryID: 1002,
        Details: "تیشه ای" ,
        CompanyName: "لاشتر" , 
    },
    {
        ID : 117 ,
        Name: " سنگ پله ",
        ImageURL: "image/Stone/4-17.jpeg",
        CategoryID: 1002,
        Details: "مرمریت" ,
        CompanyName: "آباده" , 
    },
    {
        ID : 118 ,
        Name: " سنگ پله ",
        ImageURL: "image/Stone/4-18.jpeg",
        CategoryID: 1002,
        Details: "مرمریت تختک" ,
        CompanyName: "_" , 
    },
    {
        ID : 119 ,
        Name: " سنگ پله ",
        ImageURL: "image/Stone/4-19.jpeg",
        CategoryID: 1002,
        Details: "مرمریت صلصالی" ,
        CompanyName: "_" , 
    },
    {
        ID : 120 ,
        Name: " سنگ تیشه ای ",
        ImageURL: "image/Stone/4-12.jpeg",
        CategoryID: 1002,
        Details: "پرطاووسی" ,
        CompanyName: "_" , 
    },
    {
        ID : 121 ,
        Name: " سنگ تیشه ای ",
        ImageURL: "image/Stone/4-13.jpeg",
        CategoryID: 1002,
        Details: "" ,
        CompanyName: "لاشتر" , 
    },
    {
        ID : 122 ,
        Name: " سنگ گفپوش ",
        ImageURL: "image/Stone/4-26.jpeg",
        CategoryID: 1002,
        Details: "الگویی" ,
        CompanyName: "هرسین" , 
    },
    {
        ID : 123 ,
        Name: " سنگ گفپوش ",
        ImageURL: "image/Stone/4-27.jpeg",
        CategoryID: 1002,
        Details: "تیشه ای" ,
        CompanyName: "لاشتر" , 
    },
    {
        ID : 124 ,
        Name: " سنگ گفپوش ",
        ImageURL: "image/Stone/4-28.jpeg",
        CategoryID: 1002,
        Details: " مرمریت" ,
        CompanyName: "آباده" , 
    },
    {
        ID : 125 ,
        Name: " سنگ گفپوش ",
        ImageURL: "image/Stone/4-32.jpeg",
        CategoryID: 1002,
        Details: " مرمریت پرطاووسی " ,
        CompanyName: "یزد" , 
    },
    {
        ID : 126 ,
        Name: " سنگ گفپوش ",
        ImageURL: "image/Stone/4-29.jpeg",
        CategoryID: 1002,
        Details: " مرمریت تختک " ,
        CompanyName: "_" , 
    },
    {
        ID : 127 ,
        Name: " سنگ گفپوش ",
        ImageURL: "image/Stone/4-30.jpeg",
        CategoryID: 1002,
        Details: " مرمریت خوی " ,
        CompanyName: "_" , 
    },
    {
        ID : 128 ,
        Name: " سنگ گفپوش ",
        ImageURL: "image/Stone/4-31.jpeg",
        CategoryID: 1002,
        Details: " مرمریت  " ,
        CompanyName: "صلصالی" , 
    },
    {
        ID : 129 ,
        Name: " سنگ گفپوش ",
        ImageURL: "image/Stone/4-33.jpeg",
        CategoryID: 1002,
        Details: " مرمریت  " ,
        CompanyName: "لاشتر" , 
    },
    {
        ID : 130 ,
        Name: " سنگ گفپوش ",
        ImageURL: "image/Stone/4-34.jpeg",
        CategoryID: 1002,
        Details: " مرمریت  " ,
        CompanyName: "نجف آباد" , 
    },
    {
        ID : 132 ,
        Name: " سنگ مرمریت ",
        ImageURL: "image/Stone/4-21.jpeg",
        CategoryID: 1002,
        Details: " 40 طولی  " ,
        CompanyName: "آباده" , 
    },
    {
        ID : 133 ,
        Name: " سنگ مرمریت ",
        ImageURL: "image/Stone/4-24.jpeg",
        CategoryID: 1002,
        Details: "پرشین اسکار" ,
        CompanyName: "_" , 
    },
    {
        ID : 134 ,
        Name: " سنگ مرمریت ",
        ImageURL: "image/Stone/4-25.jpeg",
        CategoryID: 1002,
        Details: " پرطاووسی" ,
        CompanyName: "یزد" , 
    },
    {
        ID : 135 ,
        Name: " سنگ مرمریت ",
        ImageURL: "image/Stone/4-23.jpeg",
        CategoryID: 1002,
        Details: " جوشقان" ,
        CompanyName: "_" , 
    },
    {
        ID : 136 ,
        Name: " کفپوش تیشه ای ",
        ImageURL: "image/Stone/4-36.jpeg",
        CategoryID: 1002,
        Details: " مرمریت" ,
        CompanyName: "نجف آباد" , 
    },
    {
        ID : 137 ,
        Name: " کفپوش سنگ ",
        ImageURL: "image/Stone/4-37.jpeg",
        CategoryID: 1002,
        Details: " مرمریت چینی ریز60 در 60" ,
        CompanyName: "نجف آباد" , 
    },
    {
        ID : 139 ,
        Name: " سنگ مرمریت",
        ImageURL: "image/Stone/4-29.jpeg",
        CategoryID: 1002,
        Details: "تختک طولی" ,
        CompanyName: "_" , 
    },
    {
        ID : 140 ,
        Name: " سنگ بادبر",
        ImageURL: "image/Stone/4-38.jpeg",
        CategoryID: 1002,
        Details: "" ,
        CompanyName: "صلصالی" , 
    },
    {
        ID : 141 ,
        Name: " سنگ اسلب",
        ImageURL: "image/Stone/2-1.jpeg",
        CategoryID: 1003,
        Details: "گرانیت بلک زبرا" ,
        CompanyName: "_" , 
    },
    {
        ID : 142 ,
        Name: " سنگ اسلب",
        ImageURL: "image/Stone/2-2.jpeg",
        CategoryID: 1003,
        Details: "گرانیت سبز درباری چرمی" ,
        CompanyName: "_" , 
    },
    {
        ID : 143 ,
        Name: " سنگ گرانیت",
        ImageURL: "image/Stone/2-3.jpeg",
        CategoryID: 1003,
        Details: "حبیب اللهی" ,
        CompanyName: "_" , 
    },
    {
        ID : 144 ,
        Name: " سنگ گرانیت",
        ImageURL: "image/Stone/2-4.jpeg",
        CategoryID: 1003,
        Details: "نطنز محمدی" ,
        CompanyName: "_" , 
    },
    {
        ID : 145 ,
        Name: " سنگ گرانیت",
        ImageURL: "image/Stone/2-5.jpg",
        CategoryID: 1003,
        Details: "نهبندان" ,
        CompanyName: "_" , 
    },
    {
        ID : 146 ,
        Name: " سنگ مرمر ",
        ImageURL: "image/Stone/3-1.jpeg",
        CategoryID: 1004,
        Details: "گلدن کلودی شلوغس" ,
        CompanyName: "_" , 
    },
    {
        ID : 147 ,
        Name: " سنگ آنتیک ",
        ImageURL: "image/Stone/3-2.jpeg",
        CategoryID: 1004,
        Details: "انیکس مرمر" ,
        CompanyName: "_" , 
    },
    {
        ID : 148 ,
        Name: " سنگ آنتیک ",
        ImageURL: "image/Stone/3-3.jpeg",
        CategoryID: 1004,
        Details: "سیاه سفید" ,
        CompanyName: "_" , 
    },
    {
        ID : 149 ,
        Name: " سنگ آنتیک ",
        ImageURL: "image/Stone/3-4.jpeg",
        CategoryID: 1004,
        Details: "مرمر مربع کوچک و بزرگ" ,
        CompanyName: "_" , 
    },
    {
        ID : 151 ,
        Name: " سنگ اسلب ",
        ImageURL: "image/Stone/3-9.jpeg",
        CategoryID: 1004,
        Details: "مرمر پرنسس" ,
        CompanyName: "_" , 
    },
    {
        ID : 152 ,
        Name: " سنگ اسلب ",
        ImageURL: "image/Stone/3-6.jpeg",
        CategoryID: 1004,
        Details: "مرمر رومانسی موج دار" ,
        CompanyName: "_" , 
    },
    {
        ID : 153 ,
        Name: " سنگ اسلب ",
        ImageURL: "image/Stone/3-7.jpeg",
        CategoryID: 1004,
        Details: "مرمر سبز" ,
        CompanyName: "_" , 
    },
    {
        ID : 154 ,
        Name: " سنگ اسلب ",
        ImageURL: "image/Stone/3-8.jpeg",
        CategoryID: 1004,
        Details: "مرمر صورتی" ,
        CompanyName: "_" , 
    },
    {
        ID : 155 ,
        Name: " سنگ اسلب ",
        ImageURL: "image/Stone/3-10.jpeg",
        CategoryID: 1004,
        Details: "مرمر گلدن کلودی" ,
        CompanyName: "_" , 
    },
    {
        ID : 156 ,
        Name: " سنگ اسلب ",
        ImageURL: "image/Stone/3-11.jpeg",
        CategoryID: 1004,
        Details: "مرمر مولتی کالر عسلی" ,
        CompanyName: "_" , 
    },
    {
        ID : 62 ,
        Name: " سنگ مرمریت ",
        ImageURL: "image/new-cat-2-2.jpeg",
        CategoryID: 1002,
        Details: "" ,
        CompanyName: "تهران" , 
    },
    {
        ID : 63 ,
        Name: " سنگ گرانیت ",
        ImageURL: "image/new-cat-2-3.jpeg",
        CategoryID: 1003,
        Details: "" ,
        CompanyName: "_" , 
    },
    {
        ID : 65 ,
        Name: " سنگ عباس آباد ",
        ImageURL: "image/new-cat-2-4.jpeg",
        CategoryID: 1005,
        Details: "" ,
        CompanyName: "_" , 
    },
    {
        ID : 66 ,
        Name: " سنگ لاشتر ",
        ImageURL: "image/new-cat-2-5.jpeg",
        CategoryID: 1006,
        Details: "" ,
        CompanyName: "_" , 
    },
    // {
    //     ID : 7 ,
    //     Name: "متنی ساختگی 7 ",
    //     ImageURL: "image/cat-2-7.jpg"
    // },
    // {
    //     ID : 8 ,
    //     Name: "متنی ساختگی 8 ",
    //     ImageURL: "image/cat-2-8.jpg"
    // },
]

export default ProductSang;